import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import addressApi, {
  MUTATION_REVALIDATE_PROPERTY_ADDRESS
} from "api/landlord/address";

interface RecheckAddressButtonProps {
  propertyId: string | number;
}

export const RecheckAddressButton = ({
  propertyId
}: RecheckAddressButtonProps) => {
  const queryClient = useQueryClient();

  const { mutate: recheck, isPending } = useMutation({
    mutationKey: [MUTATION_REVALIDATE_PROPERTY_ADDRESS, String(propertyId)],
    mutationFn: () => addressApi.revalidatePropertyAddress(propertyId),
    onSuccess: () => {
      toast.success(
        "Re-checking this address. The status updates in a few moments."
      );
      queryClient.invalidateQueries({
        queryKey: ["properties", String(propertyId)]
      });
    },
    onError: () => {
      toast.error("Couldn't start the address check. Please try again.");
    }
  });

  return (
    <Button
      size={ButtonSize.SM}
      variant={ButtonVariant.BASE}
      loading={isPending}
      disabled={isPending}
      onClick={() => recheck()}
    >
      Re-check address
    </Button>
  );
};
